import styled, { css } from 'styled-components';
import { Button } from '@devsbb/ui';
import { Group } from '@/components/Group';

export const Root = styled(Group)<{
  isMobile: boolean;
  isLoading?: boolean;
  bgColor?: string;
}>`
  ${({ isMobile }) =>
    isMobile &&
    css`
      margin: 0 calc(50% - 50vw) 16px;
    `}
  padding: ${({ isMobile }) =>
    isMobile ? '16px' : '16px max(72px, calc((100% - 1600px) / 2 + 72px))'};
  background-color: ${({ theme, isLoading, bgColor }) =>
    isLoading ? theme.colors.background.superLightGrey : bgColor};
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const Content = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  align-items: ${({ isMobile }) => (isMobile ? 'stretch' : 'center')};
  gap: ${({ theme }) => theme.spacers['2M']};
  flex: 1;
  min-width: 0;
  justify-content: space-between;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  max-width: 720px;
`;

export const ButtonsWrapper = styled.div`
  flex-shrink: 0;
`;

export const CloseButton = styled.button<{ isMobile: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-self: ${({ isMobile }) => (isMobile ? 'flex-start' : 'center')};
  padding: 0;
  margin-left: ${({ theme }) => theme.spacers['XXL']};
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  cursor: pointer;
`;

export const ViewDetailsButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.background.white};
  color: ${({ theme }) => theme.colors.text.darkerGrey};

  :hover {
    background-color: ${({ theme }) => theme.colors.hover.lighterGrey};
  }
`;
